import { render, staticRenderFns } from "./PopupWhoWeAre.vue?vue&type=template&id=55c89761"
import script from "./PopupWhoWeAre.vue?vue&type=script&lang=js"
export * from "./PopupWhoWeAre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports